<template>
    <div v-if="show" class="loading">
        <div class="box">
            <img src="@/assets/image/loading.png" width="50">
            <p>{{message}}</p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            message: '처리중...'
        }
    },
    created() {

    }
}
</script>

<style scoped>
.loading {
    z-index: 100000; position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background-color: rgba(255, 255, 255, .5);
    display: flex; flex-direction: row; align-items: center; justify-content: center; overflow: hidden;
}
.loading .box {
    width: 120px; height: 120px; background-color: rgba(0, 0, 0, .7); text-align: center; border-radius: 15px;
    display: flex; flex-direction: column; justify-content: center; align-items: center;
}
.loading p {color: #fff; margin-top: 10px; font-size: .9rem;}
</style>



// WEBPACK FOOTER //
// src/components/progressComponent.vue